import ContinuePage from "@components/ContinuePage"

export default function PetsAlmostTherePage() {
  return <ContinuePage emoji="🏁" translationKey="petsAlmostThere" />
}
